import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { prefixLanguage } from '@/utils/urls'


export default /*@__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    item: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props

const vacancyUrl = computed(() => {
  const base = prefixLanguage('vacancies')
  const baseNorm = base.startsWith('/') ? base : `/${base}`
  return `${baseNorm}${baseNorm.endsWith('/') ? '' : '/'}${props.item.slug}/`
})

const salaryText = computed(() => {
  const salaryFrom = props.item.salaryFrom ?? props.item.salary_from
  const salaryTo = props.item.salaryTo ?? props.item.salary_to
  const curr = props.item.currency?.label || 'грн'
  if (!salaryFrom && !salaryTo) return ''
  if (!salaryTo) return `${formatNum(salaryFrom)} ${curr}`
  return `${formatNum(salaryFrom)} - ${formatNum(salaryTo)} ${curr}`
})

function formatNum(n: number | null): string {
  if (n == null) return ''
  return n.toLocaleString('uk-UA')
}

const __returned__ = { props, vacancyUrl, salaryText, formatNum, computed, get prefixLanguage() { return prefixLanguage } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})